
      import { createLanguage, createTranslationFile } from '@vocab/webpack/web';
      
    const translations = createTranslationFile({
      "en": createLanguage(
        require.resolveWeak("./translations.json-en-virtual.json!=!../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZWxldGUiOiJEZWxldGUiLCJDYW5jZWwiOiJDYW5jZWwifQ==!"),
        () => import(
          /* webpackChunkName: "en-translations" */
          "./translations.json-en-virtual.json!=!../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZWxldGUiOiJEZWxldGUiLCJDYW5jZWwiOiJDYW5jZWwifQ==!"
        )
      ),
"th": createLanguage(
        require.resolveWeak("./translations.json-th-virtual.json!=!../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZWxldGUiOiLguKXguJoiLCJDYW5jZWwiOiLguKLguIHguYDguKXguLTguIEifQ==!"),
        () => import(
          /* webpackChunkName: "th-translations" */
          "./translations.json-th-virtual.json!=!../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZWxldGUiOiLguKXguJoiLCJDYW5jZWwiOiLguKLguIHguYDguKXguLTguIEifQ==!"
        )
      ),
"id": createLanguage(
        require.resolveWeak("./translations.json-id-virtual.json!=!../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZWxldGUiOiJIYXB1cyIsIkNhbmNlbCI6IkJhdGFsIn0=!"),
        () => import(
          /* webpackChunkName: "id-translations" */
          "./translations.json-id-virtual.json!=!../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZWxldGUiOiJIYXB1cyIsIkNhbmNlbCI6IkJhdGFsIn0=!"
        )
      ),
"en-AU": createLanguage(
        require.resolveWeak("./translations.json-en-AU-virtual.json!=!../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZWxldGUiOiJEZWxldGUiLCJDYW5jZWwiOiJDYW5jZWwifQ==!"),
        () => import(
          /* webpackChunkName: "en-AU-translations" */
          "./translations.json-en-AU-virtual.json!=!../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZWxldGUiOiJEZWxldGUiLCJDYW5jZWwiOiJDYW5jZWwifQ==!"
        )
      ),
"en-HK": createLanguage(
        require.resolveWeak("./translations.json-en-HK-virtual.json!=!../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZWxldGUiOiJEZWxldGUiLCJDYW5jZWwiOiJDYW5jZWwifQ==!"),
        () => import(
          /* webpackChunkName: "en-HK-translations" */
          "./translations.json-en-HK-virtual.json!=!../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZWxldGUiOiJEZWxldGUiLCJDYW5jZWwiOiJDYW5jZWwifQ==!"
        )
      ),
"en-ID": createLanguage(
        require.resolveWeak("./translations.json-en-ID-virtual.json!=!../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZWxldGUiOiJEZWxldGUiLCJDYW5jZWwiOiJDYW5jZWwifQ==!"),
        () => import(
          /* webpackChunkName: "en-ID-translations" */
          "./translations.json-en-ID-virtual.json!=!../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZWxldGUiOiJEZWxldGUiLCJDYW5jZWwiOiJDYW5jZWwifQ==!"
        )
      ),
"en-MY": createLanguage(
        require.resolveWeak("./translations.json-en-MY-virtual.json!=!../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZWxldGUiOiJEZWxldGUiLCJDYW5jZWwiOiJDYW5jZWwifQ==!"),
        () => import(
          /* webpackChunkName: "en-MY-translations" */
          "./translations.json-en-MY-virtual.json!=!../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZWxldGUiOiJEZWxldGUiLCJDYW5jZWwiOiJDYW5jZWwifQ==!"
        )
      ),
"en-NZ": createLanguage(
        require.resolveWeak("./translations.json-en-NZ-virtual.json!=!../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZWxldGUiOiJEZWxldGUiLCJDYW5jZWwiOiJDYW5jZWwifQ==!"),
        () => import(
          /* webpackChunkName: "en-NZ-translations" */
          "./translations.json-en-NZ-virtual.json!=!../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZWxldGUiOiJEZWxldGUiLCJDYW5jZWwiOiJDYW5jZWwifQ==!"
        )
      ),
"en-PH": createLanguage(
        require.resolveWeak("./translations.json-en-PH-virtual.json!=!../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZWxldGUiOiJEZWxldGUiLCJDYW5jZWwiOiJDYW5jZWwifQ==!"),
        () => import(
          /* webpackChunkName: "en-PH-translations" */
          "./translations.json-en-PH-virtual.json!=!../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZWxldGUiOiJEZWxldGUiLCJDYW5jZWwiOiJDYW5jZWwifQ==!"
        )
      ),
"en-SG": createLanguage(
        require.resolveWeak("./translations.json-en-SG-virtual.json!=!../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZWxldGUiOiJEZWxldGUiLCJDYW5jZWwiOiJDYW5jZWwifQ==!"),
        () => import(
          /* webpackChunkName: "en-SG-translations" */
          "./translations.json-en-SG-virtual.json!=!../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZWxldGUiOiJEZWxldGUiLCJDYW5jZWwiOiJDYW5jZWwifQ==!"
        )
      ),
"en-TH": createLanguage(
        require.resolveWeak("./translations.json-en-TH-virtual.json!=!../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZWxldGUiOiJEZWxldGUiLCJDYW5jZWwiOiJDYW5jZWwifQ==!"),
        () => import(
          /* webpackChunkName: "en-TH-translations" */
          "./translations.json-en-TH-virtual.json!=!../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZWxldGUiOiJEZWxldGUiLCJDYW5jZWwiOiJDYW5jZWwifQ==!"
        )
      ),
"th-TH": createLanguage(
        require.resolveWeak("./translations.json-th-TH-virtual.json!=!../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZWxldGUiOiLguKXguJoiLCJDYW5jZWwiOiLguKLguIHguYDguKXguLTguIEifQ==!"),
        () => import(
          /* webpackChunkName: "th-TH-translations" */
          "./translations.json-th-TH-virtual.json!=!../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZWxldGUiOiLguKXguJoiLCJDYW5jZWwiOiLguKLguIHguYDguKXguLTguIEifQ==!"
        )
      ),
"id-ID": createLanguage(
        require.resolveWeak("./translations.json-id-ID-virtual.json!=!../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZWxldGUiOiJIYXB1cyIsIkNhbmNlbCI6IkJhdGFsIn0=!"),
        () => import(
          /* webpackChunkName: "id-ID-translations" */
          "./translations.json-id-ID-virtual.json!=!../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZWxldGUiOiJIYXB1cyIsIkNhbmNlbCI6IkJhdGFsIn0=!"
        )
      ),
"en-PSEUDO": createLanguage(
        require.resolveWeak("./translations.json-en-PSEUDO-virtual.json!=!../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZWxldGUiOiJb4biK4bq94bq9xprhur3hur3hua/hur3hur1dIiwiQ2FuY2VsIjoiW8OHxIPEg8SD4LiB4Li14LmJw6fhur3hur3hur3Gml0ifQ==!"),
        () => import(
          /* webpackChunkName: "en-PSEUDO-translations" */
          "./translations.json-en-PSEUDO-virtual.json!=!../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZWxldGUiOiJb4biK4bq94bq9xprhur3hur3hua/hur3hur1dIiwiQ2FuY2VsIjoiW8OHxIPEg8SD4LiB4Li14LmJw6fhur3hur3hur3Gml0ifQ==!"
        )
      )
      });
  
      export { translations as default };
    